import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import Modal from '../../../shared/ui/Modal';
import departmentSelectors from '../../store/department/selectors';
import oitsActions from '../../store/oits/action-creators/index';
import oitsSelectors from '../../store/oits/selectors';
import trainingPhasesSelectors from '../../store/training-phases/selectors';
import trainingPhasesActions from '../../store/training-phases/action-creators/index';
import ScheduleReports from '../reports/ScheduleReports';
import ObservationPhaseDetail from '../training-phases/ObservationPhaseDetail';
import OrientationPhaseDetail from '../training-phases/OrientationPhaseDetail';
import AssignFtoGrid from './AssignFtoGrid';
import TrainingPhaseCard from './TrainingPhaseCard';
import './OitDetail.scss';
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import CreatePhaseForm from "./CreatePhaseForm";
import CustomForm from "../../../shared/components/form/CustomForm";
import trainingPhasesActionCreators from "../../store/training-phases/action-creators/index";
import CommonSearchReports from "../common/CommonSearchReports";
import DashboardTaskTraining from "../dashboard/DashboardTaskTraining";
import ReportViewSplit from "../reports/ReportViewSplit";
import ModalSplit from "../../../shared/ui/ModalSplit";
import ReportEditSplit from "../reports/ReportEditSplit";
import ScheduledReportAddSplit from "../reports/ScheduleReportAddSplit";

class OitDetail extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  constructor(props) {
    super(props);

    this.state = {
      showCreatePhaseDialog: false,
      showChangeReportPhaseDialog: false,
      currentChangPhase: null,
      currentChangePhaseReportGuid: null,
      loaded: false
    }
  }

  componentDidMount() {
    this.props.fetchTrainingPhasesForOit(this.props.match.params.oitGuid)
      .then(() => {
        this.setState({loaded: true})
      })
    if (this.props.match.params.oitGuid !== this.props.selectedOitGuid) {
      this.props.setSelectedOitGuid(this.props.match.params.oitGuid);
    }
  }

  componentWillUnmount() {
    this.props.unmountTrainingPhases();
  }

  openCreatePhase() {
    this.setState({
      showCreatePhaseDialog: true
    })
  }

  createNewPhase(data) {
    this.props.createNewPhase(this.props.match.params.oitGuid, {
      ...data,
      type: 'observation'
    }).then(() => {
      this.setState({
        showCreatePhaseDialog: false
      })
    })
  }

  onChangePhase(report) {
    this.setState({
      showChangeReportPhaseDialog: true,
      currentChangePhaseReportGuid: report.guid,
      currentChangePhase: {
        phase: report.trainingPhaseGuid,
        datetime: report.responses[0] && report.responses[0].datetime ? (report.responses[0].datetime.split('T')[0]) : null
      }
    })
  }

  updateReportPhase(data) {
    this.props.updateReport({...data, datetime: data.datetime, guid: this.state.currentChangePhaseReportGuid})
      .then(() => this.props.viewTrainingPhase(data.phase))
      .then(() => {
        this.setState({
          showChangeReportPhaseDialog: false
        })
      })

  }

  // ----------------------
  // Computed
  // ----------------------

  get isAddingObservationReport() {
    return !!this.props.isAddingObservationReport;
  }

  get isAddingScheduledReport() {
    return !!this.props.isAddingScheduledReport;
  }

  get isLoading() {
    return !this.props.selectedOit || this.props.isLoading || !this.state.loaded;
  }

  get isViewingPhase() {
    return !!this.props.selectedPhaseGuid;
  }

  get nextPendingPhase() {
    const doesOpenPhaseExist = this.props.trainingPhases.find((phase) => {
      return !!phase.openedAt && !phase.closedAt;
    });
    return doesOpenPhaseExist
      ? null
      : this.props.trainingPhases.find(phase => phase.status === 'pending');
  }

  get doesOpenPhaseExits() {
    return this.props.trainingPhases.find((phase) => {
      return !!phase.openedAt && !phase.closedAt;
    });
  }

  get phaseDetailsTitle() {
    return this.selectedPhase && this.selectedPhase.type === 'observation'
      ? `${this.props.selectedOit.getFullName()}: ${this.selectedPhase.header}`
      : 'Orientation';
  }

  get selectedPhase() {
    return !this.props.selectedPhaseGuid
      ? null
      : this.props.trainingPhases.find((phase) => {
        return phase.guid === this.props.selectedPhaseGuid;
      });
  }

  get activeTraningProgram() {
    return this.props.selectedOit.trainingTracker.trainingProgram;
  }

  get currentOitSet() {
    return this.props.match.params.oitGuid === this.props.selectedOitGuid
  }

  get changePhaseConfig() {
    return {
      fields: {
        phase: {
          type: 'select',
          label: 'Phase',
          value: 'value',
          optionLabel: 'label',
          options: this.props.trainingPhases.map(tp => ({
            value: tp.guid,
            label: tp.header
          }))
        },
        datetime: {
          type: 'date',
          label: 'Report date (optional)'
        }
      }
    }
  }

  openTraningProgramDetails(traningProgramId) {
    this.props.history.push(`/training-programs/${traningProgramId}`);
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        <Fragment>
          {!this.isLoading && this.props.selectedOit.trainingTracker && (
            <Fragment>
              <div className="app-content-header">
                <h4 className="title">
                  {this.props.selectedOit.getFullName()}
                </h4>


                {this.activeTraningProgram &&
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <CommonSearchReports oitGuid={this.props.selectedOit.guid}/>
                    Training program:
                    <span className="traning-program-link"
                          onClick={() => this.openTraningProgramDetails(this.activeTraningProgram.trainingProgramGuid)}>
                      {this.activeTraningProgram.title}
                    </span>
                  </div>
                }
              </div>
              <div className="app-content timeline">
                {this.props.trainingPhases &&
                  this.props.trainingPhases.map((phase, index) => (
                    <TrainingPhaseCard
                      key={phase.guid}
                      selectedOit={this.props.selectedOit}
                      nextPendingPhase={this.nextPendingPhase}
                      onAssignFto={(phaseGuid) => {
                        return this.props.openAssignFto(phaseGuid);
                      }}
                      onClosePhase={(phaseGuid) => {
                        return this.props.closePhase(phaseGuid);
                      }}
                      onOpenPhase={(phaseGuid) => {
                        return this.props.openPhase(phaseGuid);
                      }}
                      onReopenPhase={(phaseGuid) => {
                        return this.props.reopenPhase(phaseGuid);
                      }}
                      onViewPhase={(phaseGuid) => {
                        return this.props.viewTrainingPhase(phaseGuid);
                      }}
                      onUnassignFto={(phaseGuid) => {
                        return this.props.unassignFtoFromPhase(phaseGuid);
                      }}
                      phase={phase}
                      onHasRiskALertsChange={(hasRiskAlert) => {
                        return this.props.saveHasRiskAlerts(hasRiskAlert, phase.guid)
                      }}
                    />
                  ))}
                <div className="new-phase">
                  <button
                    className="button secondary small"
                    onClick={() => this.openCreatePhase()}>
                    Add new phase
                  </button>
                </div>
              </div>
            </Fragment>
          )}

          <Modal
            isOpen={this.props.selectedTrainingPhaseModal}
            onClose={() => this.props.closeViewPhase()}
            title={this.phaseDetailsTitle}
          >
            {this.selectedPhase &&
              this.selectedPhase.type === 'observation' && (
                <ObservationPhaseDetail phase={this.selectedPhase} trainingProgram={this.props.selectedOit}/>
              )}
            {this.selectedPhase &&
              this.selectedPhase.type === 'orientation' && (
                <OrientationPhaseDetail phase={this.selectedPhase}/>
              )}
          </Modal>
          <ModalSplit
            isOpen={this.isAddingScheduledReport}
            onClose={() => this.props.closeAddScheduledReport()}
            title={this.props.form && this.props.form.name}
          >
            <ScheduledReportAddSplit />
          </ModalSplit>

          <ModalSplit
            isOpen={this.props.isEditingReportModalOpened}
            onClose={() => this.props.closeEditReport()}
            title={
              this.props.editingReport && this.props.editingReport.formName
            }
          >
            <ReportEditSplit onChangePhase={(report) => this.onChangePhase(report)}/>
          </ModalSplit>

          <ModalSplit
            isOpen={this.props.isViewingReportModalOpened}
            onClose={() => this.props.closeViewReport()}
            title={this.props.report && this.props.report.formName}
          >
            <ReportViewSplit phase={this.selectedPhase} report={this.props.report}
                        onChangePhase={(report) => this.onChangePhase(report)}/>
          </ModalSplit>

          <Modal
            isOpen={this.props.isAssigningFto}
            title={`Assign ${this.props.ftoShortLabel} for ${!this.isLoading &&
            this.props.selectedOit.getFullName()}`}
            onClose={() => this.props.closeAssignFto()}
          >
            <AssignFtoGrid/>
          </Modal>

          <Modal
            isOpen={this.props.isSchedulingReports}
            onClose={() => this.props.closeScheduleReports()}
            title="Schedule observation reports"
          >
            <ScheduleReports/>
          </Modal>
          <Modal
            isOpen={this.state.showCreatePhaseDialog}
            onClose={() => this.setState({
              showCreatePhaseDialog: false
            })}
            title="Create new phase"
          >
            {this.state.showCreatePhaseDialog
              && <CreatePhaseForm
                onSubmit={(data) => this.createNewPhase(data)}
                isLoading={this.props.isLoading}
              />}
          </Modal>
          <Modal
            isOpen={this.state.showChangeReportPhaseDialog}
            onClose={() => this.setState({
              showChangeReportPhaseDialog: false
            })}
            title="Change phase">
            {this.state.showChangeReportPhaseDialog && (
              <CustomForm
                config={this.changePhaseConfig}
                initialValues={this.state.currentChangePhase}
                onSubmit={(data) => this.updateReportPhase(data)}
              />
            )}
          </Modal>
        </Fragment>

        {!this.isLoading && this.props.selectedOit && !this.props.selectedOit.trainingTracker &&
          <Fragment>
            <div className="text-center">
              <h3 className="p-3">{this.props.selectedOit.getFullName()}: Training Not Started</h3>
            </div>
            <div className="text-center">
              <h6 className="p-3">Go to "All {this.props.oitShortLabel} observations" and start the training</h6>
            </div>
          </Fragment>
        }
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    editingReport: trainingPhasesSelectors.editingReport(state),
    form: departmentSelectors.selectedFormFor(state),
    isAddingScheduledReport: state.trainingPhases.isAddingScheduledReport,
    isAssigningFto: !!state.oits.isAssigningFtoFor,
    isEditingReport: !!state.trainingPhases.isEditingReport,
    isEditingReportModalOpened: state.trainingPhases.isEditingReportModalOpened,
    isLoading: !!state.oits.isLoading.length,
    isSchedulingReports: state.trainingPhases.isSchedulingReports,
    isViewingReport: !!state.trainingPhases.isViewingReport,
    isViewingReportModalOpened: state.trainingPhases.isViewingReportModalOpened,
    selectedOit: oitsSelectors.selectedOit(state),
    selectedOitGuid: state.oits.selectedGuid,
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    selectedPhaseGuid: state.trainingPhases.selectedGuid,
    selectedTrainingPhaseModal: state.trainingPhases.selectedTrainingPhaseModal,
    report: trainingPhasesSelectors.viewingReport(state),
    trainingPhases: state.oits.trainingPhases,
    ftoShortLabel: departmentSettingsSelectors.ftoShortLabel(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeAddScheduledReport: () => {
      dispatch(trainingPhasesActions.closeAddScheduledReport());
    },
    closeAssignFto: () => {
      return dispatch(oitsActions.closeAssignFto());
    },
    closeEditReport: () => {
      dispatch(trainingPhasesActions.closeEditReport());
    },
    closePhase: (phaseGuid) => {
      return dispatch(oitsActions.closePhase(phaseGuid));
    },
    closeScheduleReports: () => {
      return dispatch(trainingPhasesActions.closeScheduleReports());
    },
    closeViewPhase: () => {
      return dispatch(trainingPhasesActions.closeViewTrainingPhase());
    },
    closeViewReport: () => {
      dispatch(trainingPhasesActions.closeViewReport());
    },
    fetchTrainingPhasesForOit: (oitGuid) => {
      return dispatch(oitsActions.fetchTrainingPhasesForOit(oitGuid));
    },
    createNewPhase: (oitGuid, phaseConfig) => {
      return dispatch(oitsActions.createNewPhase(oitGuid, phaseConfig))
    },
    openAssignFto: (phaseGuid) => {
      return dispatch(oitsActions.openAssignFto(phaseGuid));
    },
    openPhase: (phaseGuid) => {
      return dispatch(oitsActions.openPhase(phaseGuid));
    },
    reopenPhase: (phaseGuid) => {
      return dispatch(oitsActions.reopenPhase(phaseGuid));
    },
    setSelectedOitGuid: (oitGuid) => {
      return dispatch(oitsActions.setSelectedOitGuid(oitGuid));
    },
    viewTrainingPhase: (phaseGuid) => {
      return dispatch(trainingPhasesActions.viewTrainingPhase(phaseGuid));
    },
    unassignFtoFromPhase: (phaseGuid) => {
      return dispatch(oitsActions.unassignFtoFromPhase(phaseGuid));
    },
    unmountTrainingPhases: () => {
      return dispatch(trainingPhasesActions.unmountTrainingPhases());
    },
    saveHasRiskAlerts: (hasRiskAlert, trainingPhaseGuid) => {
      return dispatch(oitsActions.saveHasRiskAlerts(hasRiskAlert, trainingPhaseGuid));
    },
    updateReport: (formData) => {
      return dispatch(trainingPhasesActionCreators.updateReport(formData));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OitDetail));
